function getPriceTitle (price, currencies) {
  var name = ''
  price.forEach((p, i) => {
    name =
        name +
        ' ' +
        p.amount +
        ' ' +
        currencies.find((c) => {
          return c.id === p.currency.id
        }).name
    if (i + 1 < price.length) {
      name = name + ' + '
    }
  })
  return name
}

function findOptionById ({ product, optionId }) {
  const modifier = product.modifiers.find(({ options }) => options.some(({ id }) => id === optionId))
  return modifier ? modifier.options.find(({ id }) => id === optionId) : null
}

export {
  getPriceTitle,
  findOptionById,
}
